import { m } from "framer-motion";

export const MANCHESTER_IDS = [
    {
        unit: "1",
        id: "624406415",
    },
    {
        unit: "2",
        id: "624406416",
    },
    {
        unit: "3",
        id: ["624406417", "624406418", "624406414"],
    },
    {
        unit: "4",
        id: "624406419",
    },
    {
        unit: "5",
        id: "624406420",
    },
    {
        unit: "6",
        id: ["624406421", "624406423", "624406424"],
    },
    {
        unit: "7",
        id: ["624406422"],
    },
];

export interface MAPBOX_DATA_TYPE {
    unit: string;
    id: number | number[];
    clickthrough?: string;
    split?: "vertical" | "horizontal";
}

export const MAPBOX_DATA: MAPBOX_DATA_TYPE[] = [
    // Manchester
    {
        unit: "1",
        id: 624406415,
    },
    {
        unit: "2",
        id: 624406416,
    },
    {
        unit: "3",
        id: [624406417, 624406418, 624406414],
    },
    {
        unit: "4 - 5",
        id: [624406419, 624406420],
    },

    {
        unit: "6",
        id: [624406421, 624406423, 624406424],
        clickthrough: "/portfolio/112/unit-6",
    },
    {
        unit: "7",
        id: 624406422,
    },
    // Crawley,
    {
        unit: "1",
        id: 1419030088,
    },
    {
        unit: "1a",
        id: 1419030089,
    },
    {
        unit: "2",
        id: 1419030090,
    },
    {
        unit: "4",
        id: 23672397,
        clickthrough: "/portfolio/crawley/unit-4",
    },
    {
        unit: "5",
        id: 1419034356,
    },
    {
        unit: "6",
        id: 1419034357,
    },
    // Bristol
    {
        unit: "1",
        id: 619894578,
    },
    {
        unit: "2",
        id: 619894577,
    },
    {
        unit: "3",
        id: 116930770,
    },
    {
        unit: "4",
        id: 619894576,
    },
    {
        unit: "5",
        id: 224281304,
    },
    {
        unit: "6",
        id: 619894573,
    },
    {
        unit: "7",
        id: 224281305,
    },

    //Pershore,
    {
        unit: "1 - 6",
        id: [436510598, 436510604, 435598975, 436510614, 436510615, 436510616],
    },
    // {
    //     unit: "2",
    //     id: 436510604,
    // },
    // {
    //     unit: "3",
    //     id: 435598975,
    // },
    // {
    //     unit: "4",
    //     id: 436510614,
    // },
    // {
    //     unit: "5",
    //     id: 436510615,
    // },
    // {
    //     unit: "6",
    //     id: 436510616,
    // },
    {
        unit: "10 - 12",
        id: [435598979, 436510599, 436510600],
    },
    // {
    //     unit: "11",
    //     id: 436510599,
    // },
    // {
    //     unit: "12",
    //     id: 436510600,
    // },
    {
        unit: "12a",
        id: 436510601,
    },
    {
        unit: "14",
        id: 436510617,
    },
    {
        unit: "15",
        id: 436510602,
    },
    {
        unit: "18",
        id: 436510618,
    },
    {
        unit: "19 - 21",
        id: [436510603, 436510605, 436510606],
    },
    // {
    //     unit: "20",
    //     id: 436510605,
    // },
    // {
    //     unit: "21",
    //     id: 436510606,
    // },
    {
        unit: "22 - 23",
        id: [436510607, 436510608],
    },
    {
        unit: "24 - 25",
        id: [436510609, 436510610],
    },
    // {
    //     unit: "25",
    //     id: 436510610,
    // },
    {
        unit: "26",
        id: 436510611,
    },
    {
        unit: "27",
        id: 436510612,
    },
    {
        unit: "28 - 29",
        id: [436510613, 435915796],
    },
    // {
    //     unit: "29",
    //     id: 435915796,
    // },
    // {
    //     unit: "25",
    //     id: 435915789, // NEEDS BESPOKE
    // },
    {
        unit: "1",
        id: 436352749,
    },
    {
        unit: "2",
        id: 436352760,
    },
    {
        unit: "3",
        id: 436352762,
    },
    {
        unit: "4",
        id: 436352766,
    },
    {
        unit: "5 - 10",
        id: [436352759, 436352764, 436352765, 436352758, 436352763, 436352757],
    },
    // {
    //     unit: "7 - 8",
    //     id: [436352765, 436352758],
    // },
    // {
    //     unit: "9-10",
    //     id: [436352763, 436352757],
    // },

    {
        unit: "",
        id: 435915850, // OUTHOUSE
    },
    {
        unit: "18",
        id: 435915849,
    },
    {
        unit: "15-17",
        id: [436352755, 436352754, 436352753],
    },
    // {
    //     unit: "39",
    //     id: [436352753],
    // },
    {
        unit: "11-14",
        id: [436352751, 436352750, 436352752],
    },
];
//MK
// 87685915,
// 87685917,
// 87685925,
// 87685914,
//Leeds, needs bespoke
// {
//     unit: "1",
//     id: 223128239,
// },

//     //PERSHORE,

export const BESPOKE_MAPDATA_LEEDS: MAPBOX_DATA_TYPE[] = [
    // Leeds
    {
        unit: "A1 / A2",
        id: [1, 2],
    },
    {
        unit: "A3 / A4",
        id: [3, 4],
    },
    {
        unit: "5 - 7",
        id: [5, 6, 7],
    },
];

export const BESPOKE_MAPDATA_MK: MAPBOX_DATA_TYPE[] = [
    {
        unit: "4",
        id: 1,
    },
    {
        unit: "3",
        id: 2,
    },
    {
        unit: "2",
        id: 3,
    },
    {
        unit: "1",
        id: 4,
    },
    {
        unit: "5",
        id: 5,
    },
    {
        unit: "6",
        id: 6,
        clickthrough: "/portfolio/saxon-park/unit-6",
    },
    {
        unit: "7",
        id: 7,
    },
    {
        unit: "8",
        id: 8,
    },
    {
        unit: "9",
        id: 9,
    },
    {
        unit: "10",
        id: 10,
    },
    {
        unit: "11",
        id: 11,
    },
    {
        unit: "12",
        id: 12,
    },
];
export const BESPOKE_MAPDATA_SHEFFIELD: MAPBOX_DATA_TYPE[] = [
    {
        unit: "1a",
        id: 1,
    },
    {
        unit: "1b",
        id: 2,
    },
    {
        unit: "2",
        id: 3,
    },
    {
        unit: "3",
        id: 4,
    },
    {
        unit: "4",
        id: 5,
    },
];

export const BESPOKE_MAPDATA_PERSHORE: MAPBOX_DATA_TYPE[] = [
    {
        unit: "19-20",
        id: [1, 2],
    },
    // {
    //     unit: "20",
    //     id: 2,
    // },
    {
        unit: "21-23",
        id: [3, 4, 5],
    },
    // {
    //     unit: "22",
    //     id: 4,
    // },
    // {
    //     unit: "23",
    //     id: 5,
    // },
    {
        unit: "24-25",
        id: [6, 7],
    },
    // {
    //     unit: "25",
    //     id: 7,
    // },
    {
        unit: "26-28",
        id: [8, 9, 10],
    },
    // {
    //     unit: "27",
    //     id: 9,
    // },
    // {
    //     unit: "28",
    //     id: 10,
    // },
    {
        unit: "1",
        id: 11,
    },
    {
        unit: "2",
        id: 12,
    },
    {
        unit: "3",
        id: 13,
    },
    {
        unit: "4",
        id: 14,
    },
    {
        unit: "5",
        id: 15,
    },
    {
        unit: "6",
        id: 16,
    },
    {
        unit: "7",
        id: 17,
    },
    {
        unit: "8",
        id: 18,
    },
    {
        unit: "9",
        id: 19,
    },
    {
        unit: "10",
        id: 20,
    },
    {
        unit: "11",
        id: 21,
    },
    {
        unit: "12",
        id: 22,
    },
    {
        unit: "1",
        id: 23,
    },
    {
        unit: "2",
        id: 24,
    },
    {
        unit: "3 - 4",
        id: [25, 26],
    },
    // {
    //     unit: "4",
    //     id: 26,
    // },
    {
        unit: "5",
        id: 27,
    },
    {
        unit: "6 - 8",
        id: [28, 29, 30],
    },
    // {
    //     unit: "7",
    //     id: 29,
    // },
    // {
    //     unit: "8",
    //     id: 30,
    // },
    {
        unit: "9",
        id: 31,
    },
    {
        unit: "10",
        id: 32,
    },
    {
        unit: "11",
        id: 33,
    },
    {
        unit: "12",
        id: 34,
    },
    {
        unit: "14 - 14a",
        id: [35, 36],
    },
    // {
    //     unit: "14b",
    //     id: 36,
    // },
];
